// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"5e633511","54":"08266a5a","131":"a8caf339","288":"20758156","435":"3e04dc14","487":"5a6f7a51","695":"4c4ac8c0"}[chunkId] + ".css";
};